import get from 'lodash/get';
import { Action, Article } from 'types';
export interface ArticleReducer {
  [slug: string]: Article;
}
const initialState: ArticleReducer = {};
export default (
  state: ArticleReducer = initialState,
  action: Action
): ArticleReducer => {
  switch (action.type) {
    case 'FETCH_ARTICLE_OR_TOPIC_FULFILLED':
      if (get(action, 'payload.type') === 'article') {
        return {
          ...state,
          [get(action, 'payload.slug', '')]: action.payload as Article,
        };
      }
      return { ...state };
    default:
      return state;
  }
};
